import { IIntegration, IntegrationType } from '@principle-theorem/integrations';
import { IBaseSMSIntegrationData } from './sms-integration';

export interface ITNZIntegrationData extends IBaseSMSIntegrationData {
  enabled: boolean;
  testModeEnabled: boolean;
}

export function isTNZIntegration(
  item: IIntegration
): item is IIntegration<ITNZIntegrationData> {
  return item.type === IntegrationType.TNZ;
}
